import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";

export default class SettlementPayment extends BaseModel {
  uuid = null;
  settlement_no = null;
  amount = null;
  initial_amount = null;
  converted_amount = null;

  rules = {
    settlement_no: 'required',
    amount: 'required',
  };

  attributeLabels = {
    settlement_no: i18n.t('Settlement'),
    amount: i18n.t('Amount'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initial_amount = this.amount
  }
}

defineTranslatableProperties(SettlementPayment);
